export class KuxError extends Error {
  code: number | string;
  httpStatus?: number;

  constructor(message: string, code: number | string = 1, httpStatus?: number) {
    super(message);
    this.code = code;
    this.httpStatus = httpStatus;
  }
}

export enum PurchaseErrors {
  accessTokenNotPassed = '999001',
  accessTokenInvalid = '999002',
}

export const ProviderLinkNotFound = 'Content is not supported';

export const TIMEOUT_ERROR = '408';
